import { Injectable, Inject } from '@angular/core';
import { ReplaySubject, Observable } from 'rxjs';
import { DOCUMENT } from '@angular/common';

@Injectable()
export class LazyLoadingScriptService {
  _loadedLibraries: { [url: string]: ReplaySubject<any> } = {};

  constructor(@Inject(DOCUMENT) private readonly document: any) {}

  loadScript(
    url: string,
    isAsync: boolean,
    scriptType: string = 'text/javascript',
    crossOrigin = null,
  ): Observable<any> {
    if (this._loadedLibraries[url]) {
      return this._loadedLibraries[url].asObservable();
    }

    this._loadedLibraries[url] = new ReplaySubject();

    const script = this.document.createElement('script');
    script.type = scriptType;
    script.src = url;
    script.crossOrigin = crossOrigin;
    script.async = isAsync;
    script.onload = () => {
      this._loadedLibraries[url].next();
      this._loadedLibraries[url].complete();
    };

    (this.document.getElementsByTagName('head')[0] || this.document.body).appendChild(script);

    return this._loadedLibraries[url].asObservable();
  }
}
